// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    height: 100vh;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    font-family:
        'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.song-workspace {
    display: flex;
    flex-direction: row;
    justify-content: safe;
    margin: 10px;
}
.song-controls {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}
.song-controls .counter {
    white-space: nowrap;
}
.position-editor {
    overflow-x: scroll;
    /* margin: 10px; */
}
.position-editor table {
    border-collapse: separate;
}
.position-editor th,
.position-editor td {
    border-top: none;
    border-left: none;
    border-right: 1px solid #888;
    border-bottom: 1px solid #888;
}
.position-editor th[scope='col'] {
    font-weight: normal;
    color: #aaa;
    text-align: center;
    padding: 0;
}
.position-editor th:first-child {
    position: sticky;
    background-color: white;
    padding: 0 10px 0 0;
    width: 100px;
    left: 0;
}
.position-editor td {
    min-width: 24px;
}

.pattern-editor {
    overflow-y: scroll;
}
.pattern-table {
    overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/main.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB;wEACoE;AACxE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,OAAO;AACX;AACA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB","sourcesContent":["body {\n    height: 100vh;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    font-family:\n        'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n}\n\n.song-workspace {\n    display: flex;\n    flex-direction: row;\n    justify-content: safe;\n    margin: 10px;\n}\n.song-controls {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n}\n.song-controls .counter {\n    white-space: nowrap;\n}\n.position-editor {\n    overflow-x: scroll;\n    /* margin: 10px; */\n}\n.position-editor table {\n    border-collapse: separate;\n}\n.position-editor th,\n.position-editor td {\n    border-top: none;\n    border-left: none;\n    border-right: 1px solid #888;\n    border-bottom: 1px solid #888;\n}\n.position-editor th[scope='col'] {\n    font-weight: normal;\n    color: #aaa;\n    text-align: center;\n    padding: 0;\n}\n.position-editor th:first-child {\n    position: sticky;\n    background-color: white;\n    padding: 0 10px 0 0;\n    width: 100px;\n    left: 0;\n}\n.position-editor td {\n    min-width: 24px;\n}\n\n.pattern-editor {\n    overflow-y: scroll;\n}\n.pattern-table {\n    overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
